module.exports = __webpack_public_path__ + "img/icon_arrow-down-dark.d4b991eb.svg";